import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  Grid,
  Button,
  Icon,
  Transition,
} from 'semantic-ui-react'

import './carousel.css'


const propTypes = {
  slides: PropTypes.array.isRequired,
  columnWidths: PropTypes.array,
  scrollOverlay: PropTypes.bool,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  slideMarkerIcon: PropTypes.string,
  slideMarkerSelectedIcon: PropTypes.string,
  slideLeftAnimation: PropTypes.string,
  slideRightAnimation: PropTypes.string,
  duration: PropTypes.number,
}

const defaultProps = {
  // slides: [],
  columnWidths: [4, 8, 4],
  scrollOverlay: false,
  leftIcon: 'chevron circle left',
  rightIcon: 'chevron circle right',
  slideMarkerIcon: 'circle outline',
  slideMarkerSelectedIcon: 'circle',
  slideLeftAnimation: 'fly left',
  slideRightAnimation: 'fly right',
  duration: 500,
}

class Carousel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: 0,
      clickValue: 1,
      changing: false,
      // idSlides: this.props.slides.map(slide => ({
      //   id: uniqid(),
      //   slide,
      // })),
    }
  }

  // componentDidUpdate(prevProps) {
  //   const prevSlides = prevProps.slides
  //   const { slides } = this.props
  //   if (
  //     (prevSlides.length === 0 && slides.length > 0) ||
  //     (prevSlides[0] && prevSlides[0].id && prevSlides[0].slide !== slides[0])
  //   ) {
  //     this.setState({
  //       idSlides: slides.map(slide => ({
  //         id: uniqid(),
  //         slide,
  //       })),
  //     })
  //   }
  // }

  scrollSlides = (val) => {
    let { activeIndex } = this.state
    const { slides } = this.props
    if (!((activeIndex === slides.length - 1 && val === 1) || (activeIndex === 0 && val === -1))) {
      activeIndex += val
      this.setState({ activeIndex, clickValue: val })
    }
  }

  handleStart = () => {
    this.setState({ changing: true })
  }

  handleComplete = () => {
    this.setState({ changing: false })
  }

  render() {
    const { activeIndex, clickValue, changing } = this.state
    const {
      leftIcon,
      rightIcon,
      slideMarkerIcon,
      slideMarkerSelectedIcon,
      duration,
      slideLeftAnimation,
      slideRightAnimation,
      columnWidths,
      scrollOverlay,
      slides,
    } = this.props

    const firstColumnWidth = columnWidths[0] || defaultProps.columnWidths[0]
    const lastColumnWidth = columnWidths[2] || defaultProps.columnWidths[2]

    return (
      <Grid container textAlign='center'>
        <Grid.Row style={{ paddingBottom: 0 }}>
          <Grid.Column verticalAlign='middle' width={firstColumnWidth}>
            <Button
              disabled={changing || activeIndex === 0}
              style={{ marginRight: 0 }}
              onClick={() => this.scrollSlides(-1)}
              icon
            >
              <Icon name={leftIcon} />
            </Button>
          </Grid.Column>
          <Grid.Column
            style={{ padding: 0 }}
            width={scrollOverlay ? 16 : columnWidths[1] || defaultProps.columnWidths[1]}
          >
            {slides.map((slide, i) => (
              <Transition
                duration={duration}
                key={slide.id}
                visible={i === activeIndex}
                animation={
                  i < activeIndex
                    || (i === activeIndex && clickValue < 0)
                    ? slideRightAnimation : slideLeftAnimation
                }
                onStart={this.handleStart}
                onComplete={this.handleComplete}
              >
                <div
                  className={
                    i === activeIndex ? 'activeSlide' : 'transitionSlide'
                  }
                  style={{ width: '100%' }}
                >
                  {slide.slide}
                </div>
              </Transition>
            ))}
          </Grid.Column>
          <Grid.Column verticalAlign='middle' width={lastColumnWidth}>
            <Button
              disabled={changing || activeIndex === slides.length - 1}
              style={{ marginRight: 0 }}
              onClick={() => this.scrollSlides(1)}
              icon
            >
              <Icon name={rightIcon} />
            </Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ paddingTop: 0 }}>
          <Grid.Column width={16}>
            {
              slides
                .map((slide, i) => (
                  i === activeIndex
                    ? <Icon key={slide.id} name={slideMarkerSelectedIcon} />
                    : <Icon key={slide.id} name={slideMarkerIcon} />
                ))
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

Carousel.propTypes = propTypes
Carousel.defaultProps = defaultProps

export default Carousel
